module.exports = __webpack_public_path__ + "02_long_gray.4ec21b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_long_gray.png
// module id = HEhw
// module chunks = 0